/**
 * Small display helpers shared by the Bankverbindungen views (Phase 2, §7.5).
 */

/**
 * Mask an IBAN for display: keep the country + first block and the last four
 * digits, hide the middle (e.g. `DE12 •••• 3456`). Returns the input unchanged
 * when it is too short to mask, and an em-dash for null/empty.
 */
export function maskIban(iban: string | null | undefined): string {
  if (!iban) return '—';
  const compact = iban.replace(/\s+/g, '').toUpperCase();
  if (compact.length <= 8) return compact;
  const head = compact.slice(0, 4);
  const tail = compact.slice(-4);
  return `${head} •••• ${tail}`;
}
